import { mergeClassNames } from "utils/common";
import isNull from "utils/typeChecks/isNull";

import MultiTypeBonusesCard from "../multiTypeBonusesCard";
import SingleTypeBonusCard from "../singleTypeBonusCard";

const BonusesInfo = ({ className, bonuses, isSingleType, currencyCode, isMobile, isTablet, assignedGameTypes }) => {
	if (isNull(isSingleType)) {
		return null;
	}
	return (
		<div className={mergeClassNames("vs--bonus-modal-notification-info", className)}>
			{isSingleType ? (
				<SingleTypeBonusCard
					bonuses={bonuses}
					currencyCode={currencyCode}
					isMobile={isMobile}
					isTablet={isTablet}
					assignedGameTypes={assignedGameTypes}
				/>
			) : (
				<MultiTypeBonusesCard
					bonuses={bonuses}
					currencyCode={currencyCode}
					isMobile={isMobile}
					isTablet={isTablet}
					assignedGameTypes={assignedGameTypes}
				/>
			)}
		</div>
	);
};
export default BonusesInfo;
